import MapService from "./MapService";
import MapEventService from "./MapEventService";
import ObjectService from "./ObjectService";
import ChannelService from "./ChannelService";

const services = {
  map: new MapService(),
  mapEvent: new MapEventService(),
  object: new ObjectService(),
  channel: new ChannelService(),
};

export default services;
